import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';

export const mySummaryTrackedActivities = {
    NoPermissionMessage,
};
